import * as React from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";
import CheckIcon from "@mui/icons-material/Check";
import { Box } from "@mui/material";

type CustomCheckBoxProps = {
  id: number; // numeric id
  //label: string;
  label: React.ReactNode;
  checked: boolean;
  onChange: (id: number, checked: boolean) => void;
};

// Label styles
const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  ".MuiFormControlLabel-label": {
    color: "#797979",
    fontSize: "15px",
    fontWeight: 300,
    marginLeft: "10px",
  },
}));

// Custom icons
const CustomUncheckedIcon = (
  <Box
    sx={{
      width: 18,
      height: 18,
      borderRadius: "50%",
      border: "2px solid #454545",
    }}
  />
);

const CustomCheckedIcon = (
  <Box
    sx={{
      width: 18,
      height: 18,
      borderRadius: "50%",
      backgroundColor: "#6A0DAD",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <CheckIcon sx={{ fontSize: 14, color: "common.white" }} />
  </Box>
);

const CustomCheckbox = styled(Checkbox)({
  padding: 0,
});

const CustomCheckBoxNew: React.FC<CustomCheckBoxProps> = ({
  id,
  label,
  checked,
  onChange,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(id, event.target.checked);
  };

  return (
    <FormGroup>
      <StyledFormControlLabel
        sx={{ margin: "0 0 5px 0", padding: "0px" }}
        control={
          <CustomCheckbox
            checked={checked}
            onChange={handleChange}
            icon={CustomUncheckedIcon}
            checkedIcon={CustomCheckedIcon}
          />
        }
        label={label}
      />
    </FormGroup>
  );
};

export default CustomCheckBoxNew;